module.exports = __webpack_public_path__ + "img/chofu_watch_on.3d77616a.svg";